import Tooltip from "rc-tooltip";
import React from "react";
import { Button } from "semantic-ui-react";
import { ColorStop } from "../../MapStyles";
import _ from "lodash";

type Props = {
	selected: boolean;
	onClick: () => void;
	colorStops: ColorStop[] | string[];
	title: string;
	// discrete?: boolean;
};

const isDiscrete = (stops: ColorStop[] | string[]): stops is string[] => typeof stops[0] === "string";

export const GradientButton = ({ selected, onClick, colorStops, title }: Props) => {
	const gradientString = isDiscrete(colorStops)
		? _.reduce(
				colorStops,
				(acc, curr, i) => {
					const start = i / colorStops.length;
					const stop = (i + 1) / colorStops.length;
					acc += `, ${curr} ${start * 100}% ${stop * 100}%`;
					return acc;
				},
				"",
			)
		: _.reduce(
				colorStops,
				(acc, curr) => {
					acc += `, ${curr.color} ${curr.stop * 100}%`;
					return acc;
				},
				"",
			);

	return (
		<Tooltip
			placement="right"
			align={{ offset: [2, 0] }}
			mouseEnterDelay={0}
			mouseLeaveDelay={0}
			trigger="hover"
			overlay={
				<>
					<p>{title}</p>
				</>
			}
			motion={{ motionName: "rc-tooltip-zoom" }}
		>
			<Button
				className="gradientButton"
				style={{
					outline: selected ? "" : "none",
					background: `linear-gradient(90deg${gradientString})`,
				}}
				onClick={onClick}
			/>
		</Tooltip>
	);
};
